
<div class="backgroundDialog" style="width: 100%; padding: 0px;margin: auto;">



  <div style="text-align: center; width: 20%;display: inline-block;  " >
    <mat-card style="border-radius: 0px 30px 30px 0px ; color: white;
                      background-color: rgb(46, 163, 80); font-size: 20px;">
        Permissões 
    </mat-card>
  </div>
  <div style="text-align: right; width: 78%; display: inline-block; " >
    <button  [mat-dialog-close]="true">
      <img src="../../assets/img/icones/fecharJanela.png" width="100%">
  </button>
  </div>


  <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center;">
    <div style="margin-top: 7px; ">{{nomeEdicao}}</div>
  </div>

  <div style="width: 100%;">
    <table style="width: 99.8%; margin: auto;">
        <tr>
            <td style="width:100%">
                <div>
                    <mat-card class="mat-elevation-z5" style="background-color: rgb(248, 248, 248);color: rgb(138, 138, 140); height: 350px; overflow: hidden;">
                        
                        <table style="text-align: left; width: 100%; height: 98%;">
                            
                            <tr style="cursor: pointer;">
                              <td style="width: 100%" >
                                <mat-card class="mat-elevation-z5" style="font-size: 12px; height: 100%;">
                                    <div style="float: left; width: 33%; margin-top: -10px;">
                                      <b>Menu</b>    
                                    </div>
                                    <br/>
                                    <div style="text-align: left; width: 100%; height: 95%; overflow-y: auto; ">
                                      
                                      
                                      <div style="width: 100%;" *ngFor="let list of lstSlideMenus">
                                        <mat-slide-toggle [checked]="list.slide"
                                            (change)="getSlideButton($event, list.menuIdCdMenu)" >{{list.menuNmMenu}}
                                        </mat-slide-toggle>
                                        <br/>
                                      </div>


                                      
                                    </div>
                                </mat-card>
                              </td>                              
                          </tr>

                      </table>
                    </mat-card>
                </div>
            </td>
        </tr>
    </table>
    <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; text-align: center;">
      <div style="margin-top: 7px; margin-left: 15px; color: white;">RE {{reEdicao}}</div>
    </div>
  </div>

</div>